export default __webpack_public_path__ + "static/media/1718 utensils top.0d337138.png";